import {
  OmsFilterOperator,
  OmsRecordFilter,
  OmsReport,
} from "../../lusca-search-api/generated-src";

export type OmsFilterCondition = OmsRecordFilter & {
  id: number;
  valueNotice?: string;
};

export function prefersOmsChoices(report: OmsReport, column: string) {
  const choices = report.columnValues?.[column];
  return (
    choices?.complete &&
    choices.values.length > 0 &&
    !/(?:(?:^|_)id|_key)$/i.test(column)
  );
}

export function conditionOperators(
  report: OmsReport,
  criterion: OmsFilterCondition
): OmsFilterOperator[] {
  const type = report.columnTypes?.[criterion.column] || "string";
  const allowed: OmsFilterOperator[] =
    type === "string"
      ? ["eq", "ne", "contains", "notContains", "isNull", "isNotNull"]
      : ["eq", "ne", "gt", "gte", "lt", "lte", "isNull", "isNotNull"];
  if (
    type === "string" &&
    (prefersOmsChoices(report, criterion.column) ||
      criterion.values !== undefined ||
      ["in", "notIn"].includes(criterion.operator))
  )
    allowed.unshift("in", "notIn");
  return allowed;
}

export function changeCondition(
  criterion: OmsFilterCondition,
  operator: OmsFilterOperator
): OmsFilterCondition {
  if (criterion.operator === operator) return criterion;
  const next: OmsFilterCondition = {
    ...criterion,
    operator,
    valueNotice: undefined,
  };
  if (["isNull", "isNotNull"].includes(operator)) return next;
  if (["in", "notIn"].includes(operator)) {
    next.values =
      criterion.values ??
      (criterion.value !== undefined ? [criterion.value] : []);
    return next;
  }
  if (
    ["in", "notIn"].includes(criterion.operator) ||
    (criterion.value === undefined && criterion.values !== undefined)
  ) {
    next.value =
      criterion.values?.length === 1 ? criterion.values[0] : undefined;
    if (criterion.values && criterion.values.length > 1)
      next.valueNotice =
        "This condition needs one value. Your selected values are kept when you switch back.";
  }
  return next;
}

export function submittedCondition(
  criterion: OmsFilterCondition
): OmsRecordFilter {
  const { column, operator, value, values } = criterion;
  if (["isNull", "isNotNull"].includes(operator)) return { column, operator };
  if (["in", "notIn"].includes(operator))
    return { column, operator, values: values || [] };
  return { column, operator, value: value ?? "" };
}
